import * as taskName from './task-name'
import { createUIDefinition } from '../default-task-definition'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'

export default createUIDefinition({
    taskName: taskName.UPLOAD_TREATMENT_PLAN_FILES,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.TREATMENT_DURATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.TREATMENT_PLAN_FILE_UPLOAD_WIDGET,
        },
        {
            component: processUI.IMPLANT_TREATMENT_PLAN_UPLOAD_WIDGET,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
        },
        {
            component: processUI.TREATMENT_VISUALIZATION_WIDGET_CONTAINER,
        },
    ],
    actionList: [
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
        {
            action: processAction.QUOTATION_CUSTOMER_LOADED,
            taskPath: ['objectDetail', 'customer'],
        },
    ],

})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/upload-treatment-plan-files.js